export class OptionSelectorListener {
    public static bindWrapChange(wrap: HTMLElement, onChange: () => void): void {
        wrap.addEventListener("change", onChange);
    }
}
